import { Box, Divider, IconButton, useTheme } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

interface HeaderProps {
  children: React.ReactNode;
  onClose: () => any;
  rootClass?: string;
}

const Header: React.FC<HeaderProps> = ({ children, onClose, rootClass }) => {
  const { spacing } = useTheme();
  return (
    <Box
      display="flex"
      alignItems="center"
      py={12}
      {...(rootClass ? { className: rootClass } : {})}
    >
      <Box display="flex" style={{ height: '100%' }}>
        <Link to="/projects" style={{ display: 'flex' }}>
          <Logo />
        </Link>
      </Box>
      <Box display="flex" px={8} height={spacing(8)}>
        <Divider orientation="vertical" />
      </Box>
      {children}
      <Box flex="auto" />
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Box>
  );
};

Header.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Header;
